import { DialogContentText, DialogTitle } from "@mui/material";
import { FC } from "react";

type ChangeNoteProps = {
    title: string;
    notes: string[];
};

const ChangeNote: FC<ChangeNoteProps> = (props) => {
    return (
        <div className="changeNote">
            <DialogTitle className="changeNoteHeader" id="alert-dialog-title" >
                { props.title }
            </DialogTitle>
            { props.notes.map((note, index) => (
                <DialogContentText key={ index }>
                    <li >{ note }</li>
                </DialogContentText>
            )) }
        </div>
    );
};

export default ChangeNote;